import { supabase } from '../lib/supabase';
import type { RevisitFacts } from './revisit';

// Revisit's Why column (Part 2): each book's reads (where you stopped, the finish and its stars,
// why) and a pass's reason, read with your own sign-in for the books in Revisit only.

type Row = Record<string, unknown>;
const one = <T>(x: unknown): T | null => (Array.isArray(x) ? ((x[0] as T) ?? null) : ((x as T) ?? null));
const CHUNK = 120;

export async function loadRevisitFacts(ids: string[]): Promise<Map<string, RevisitFacts>> {
  const db = supabase;
  if (!db) throw new Error('Not connected to a database.');
  const out = new Map<string, RevisitFacts>(ids.map((id) => [id, { reads: [] }]));
  for (let i = 0; i < ids.length; i += CHUNK) {
    const part = ids.slice(i, i + CHUNK);
    const [reads, priv] = await Promise.all([
      db.from('reads').select('book_id, outcome, ended_on, ended_precision, stopped_percent, rating, stop_chips, created_at, read_private(stop_reason, ended_words)').in('book_id', part),
      db.from('book_private').select('book_id, not_for_me_reason').in('book_id', part),
    ]);
    if (reads.error) throw new Error(reads.error.message);
    if (priv.error) throw new Error(priv.error.message);
    for (const r of (reads.data as Row[] | null) ?? []) {
      const p = one<Row>(r.read_private);
      out.get(r.book_id as string)?.reads.push({
        outcome: r.outcome as 'open' | 'finished' | 'stopped',
        endedOn: (r.ended_on as string) ?? null,
        endedPrecision: (r.ended_precision as string) ?? null,
        endedWords: (p?.ended_words as string) ?? null,
        stoppedPercent: r.stopped_percent === null || r.stopped_percent === undefined ? null : Number(r.stopped_percent),
        rating: r.rating === null || r.rating === undefined ? null : Number(r.rating),
        chips: (r.stop_chips as string[]) ?? [],
        reason: (p?.stop_reason as string) ?? null,
        createdAt: (r.created_at as string) ?? '',
      });
    }
    for (const b of (priv.data as Row[] | null) ?? []) {
      const f = out.get(b.book_id as string);
      if (f) f.passReason = (b.not_for_me_reason as string) ?? null;
    }
  }
  return out;
}
